//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../Fields/Fields.PathObjectsList.js";
import "../no/Expression.js";
import "../Fields/Fields.PathObjects.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"BoundedObjects",0,"SelectNXObjectList",0],[0,"BoundingBoxMap",1,0],[1,"ConstUObjects",0,"Fields.PathObjectsList",0],[1,"ConstVObjects",0,"Fields.PathObjectsList",0],[0,"CoordSystem",1,"CoordinateSystem",0],[1,"EvaluationTolerance",0,"Expression",0],[1,"FaceTolerance",0,"Expression",0],[0,"FitSurfaceCoordinateSystem",1,"CoordinateSystem",0],[0,"FitSurfaceDirectionOption",1,0],[0,"FitSurfaceUDegree",1,0],[0,"FitSurfaceUPatches",1,0],[0,"FitSurfaceVDegree",1,0],[0,"FitSurfaceVPatches",1,0],[0,"FitSurfaceVector",1,"Direction",0],[1,"LatticePath",0,"Fields.PathObjects",0],[0,"MapSubtype",1,0],[0,"MapSubtypeMapping",1,0],[0,"MapType",1,0],[1,"MappingFaces",0,"SelectNXObjectList",0],[0,"OppositeCorner",1,"Point",0],[0,"Origin",1,"Point",0],[0,"ParametricPlaneMap",1,0]],[[[],"AutoTolerance",{},0,0],[["numOfLatticeColumn","numOfColumns","indep_var_array","datapoint","newNumDataPoints","parameterizedDatapoints"],"CreateLatticeMap",{R_:{latticeMap:"Fields.SpatialMap"}},4,0],[["spatialMap"],"ResetMap",{},1,0],[["origin","mtx"],"SetFitSurfaceOrientation",{},2,0],[["array_size"],"GetBoundingBox",{R_:{boundingbox:""}},0,0],[["boundingbox"],"SetBoundingBox",{},1,0]],[]];
SPLM.Fields.SpatialMapBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.SpatialMapBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Fields.SpatialMapBuilder.FitSurfaceDirectionType = Object.freeze({
    "BestFit" : "BestFit", "Vector" : "Vector", "Orientation" : "Orientation", "Csys" : "Csys"});

export default SPLM;